// src/context/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../api/services';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  var [user,    setUser]    = useState(null);
  var [loading, setLoading] = useState(true);

  useEffect(function() {
    var token = localStorage.getItem('accessToken');
    if (!token) { setLoading(false); return; }
    authAPI.me()
      .then(function(res) {
        var u = res.data.data || res.data;
        setUser(u);
      })
      .catch(function() {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
      })
      .finally(function() { setLoading(false); });
  }, []);

  var login = useCallback(function(email, password) {
    return authAPI.login({ email: email, password: password })
      .then(function(res) {
        var body = res.data.data;
        localStorage.setItem('accessToken',  body.accessToken);
        localStorage.setItem('refreshToken', body.refreshToken);
        setUser(body.user);
        return body.user;
      });
  }, []);

  var logout = useCallback(function() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    setUser(null);
  }, []);

  // Role checks
  var roleName = user ? user.role_name : '';

  // Can view all data
  var canView    = !!user;

  // Can ADD new records (Animals, Feeds, Health, Finance entries)
  var canAdd     = ['Admin','Manager','Vet'].includes(roleName);

  // Can EDIT existing records
  var canEdit    = ['Admin','Manager'].includes(roleName);

  // Can DELETE records
  var canDelete  = roleName === 'Admin';

  // Can manage users
  var canManageUsers = roleName === 'Admin';

  // Existing role aliases (keep for backward compat)
  var isAdmin   = roleName === 'Admin';
  var isManager = ['Admin','Manager'].includes(roleName);
  var isVet     = ['Admin','Manager','Vet'].includes(roleName);

  // Worker = view only + basic logging
  var isWorker  = roleName === 'Worker';

  return (
    <AuthContext.Provider value={{
      user, loading, login, logout,
      isAdmin, isManager, isVet, isWorker,
      canView, canAdd, canEdit, canDelete, canManageUsers,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}